import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Layout,
  Button,
  Typography,
  Form,
  Input,
  Card,
  Radio,
  Checkbox,
  Alert,
} from "antd";

import { connectAutoDispatch } from "../../utils/connectAutoDispatch";
import { useDispatch, useSelector } from "react-redux";
import { registerPartnerRequest } from "../../feature/auth/authSlice";

import CopyRight from "../../components/CopyRight";
import { authSelector } from "../../feature/auth/authSelector";
import usePrevious from "../../hooks/usePrevious";

const { Title } = Typography;
const { Footer, Content } = Layout;

const SignUpContainer = () => {
  const [step, setStep] = useState(1);
  const [answerSubscribed, setAnswerSubscribed] = useState();
  const [answerActively, setAnswerActively] = useState();
  const [radioFamiliar, setRadioFamiliar] = useState();
  const [message, setMesssage] = useState();
  const { isRegister, errorMessage } = useSelector(({ authState }) =>
    authSelector(authState)
  );
  const [preQualificationAnswers, setPreQualificationAnswers] = useState();
  const [checkTerms, setCheckTerms] = useState(false);
  const [checkbox, setCheckbox] = useState({
    facebook: false,
    instagram: false,
    tiktok: false,
    youtube: false,
    facebookAdmin: false,
    somewhere: false,
  });
  const [inputPromote, setInputPromote] = useState({
    facebook: "",
    instagram: "",
    tiktok: "",
    youtube: "",
    facebookAdmin: "",
    somewhere: "",
  });
  const [firstTime, setFirstTime] = useState(true);
  const [form1] = Form.useForm();
  const [form2] = Form.useForm();
  const dispatch = useDispatch();
  const prevIsRegister = usePrevious(isRegister);

  const onForm1Finish = (values) => {
    if (
      (!checkbox.facebook || !inputPromote.facebook) &&
      (!checkbox.facebookAdmin || !inputPromote.facebookAdmin) &&
      (!checkbox.instagram || !inputPromote.instagram) &&
      (!checkbox.tiktok || !inputPromote.tiktok) &&
      (!checkbox.youtube || !inputPromote.youtube) &&
      (!checkbox.somewhere || !inputPromote.somewhere)
    )
      return;
    const reasonText = `Reason: ${values.reason}`;
    const answerSubscribedText = `\nCurrently subscribed: ${answerSubscribed}`;
    const emailYourAccountText = values.emailYourAccount
      ? `\nAsinzen account: ${values.emailYourAccount}`
      : "";
    const familiarText = values.familiar
      ? `\nHow familiar: ${radioFamiliar}`
      : "";
    const answerActivelyText = `\nActive selling on Amazon: ${answerActively}`;
    const howlongText = values.howLong ? `\nHow long: ${values.howLong}` : "";
    const facebookText = inputPromote.facebook
      ? `\nPart of Facebook groups: ${inputPromote.facebook}`
      : "";
    const instagramText = inputPromote.instagram
      ? `\nInstagram: ${inputPromote.instagram}`
      : "";
    const tiktokText = inputPromote.tiktok
      ? `\nTikTok: ${inputPromote.tiktok}`
      : "";
    const youtubeText = inputPromote.youtube
      ? `\nYoutube channel: ${inputPromote.youtube}`
      : "";
    const facebookAdminText = inputPromote.facebookAdmin
      ? `\nAdmin of Facebook groups: ${inputPromote.facebookAdmin}`
      : "";
    const somewhereText = inputPromote.somewhere
      ? `\nSomewhere esle: ${inputPromote.somewhere}`
      : "";
    setPreQualificationAnswers(
      `${reasonText}${answerSubscribedText}${emailYourAccountText}${familiarText}${answerActivelyText}${howlongText}${facebookText}${instagramText}${tiktokText}${youtubeText}${facebookAdminText}${somewhereText}`
    );
    setStep(2);
  };

  const onForm2Finish = (values) => {
    const email = values.email.toLowerCase().replace(/\s/g, "");
    const paypalEmail = values.paypalEmail.toLowerCase().replace(/\s/g, "");
    form2.setFieldsValue({ email, paypalEmail });
    dispatch(
      registerPartnerRequest({
        firstName: values.firstName,
        lastName: values.lastName,
        email,
        paypalEmail,
        paypalName: values.paypalName,
        code: values.code,
        password: values.password,
        companyName: values.companyName,
        preQualificationAnswers,
      })
    );
  };

  const onChange = () => {
    setMesssage(null);
  };

  const onCheckTerms = (e) => {
    setCheckTerms(e.target.checked);
    onChange();
  };

  useEffect(() => {
    if (
      !firstTime &&
      (!checkbox.facebook || !inputPromote.facebook) &&
      (!checkbox.facebookAdmin || !inputPromote.facebookAdmin) &&
      (!checkbox.instagram || !inputPromote.instagram) &&
      (!checkbox.tiktok || !inputPromote.tiktok) &&
      (!checkbox.youtube || !inputPromote.youtube) &&
      (!checkbox.somewhere || !inputPromote.somewhere)
    )
      form1.setFields([
        {
          name: "error-promote",
          errors: ["Please input your answer!"],
        },
      ]);
    else {
      form1.setFields([
        {
          name: "error-promote",
          errors: [],
        },
      ]);
    }
  }, [form1, checkbox, firstTime, inputPromote]);

  useEffect(() => {
    if (prevIsRegister && !isRegister) {
      if (errorMessage) {
        setMesssage({ text: errorMessage.text, type: errorMessage.type });
      } else {
        setMesssage(null);
        setStep(3);
      }
    }
  }, [isRegister]);

  return (
    <>
      <div className="layout-default ant-layout layout-sign-up">
        <Content className="p-0">
          <div className="sign-up-header">
            <div className="content">
              <Title>Sign Up</Title>
              <p className="text-lg">
                Apply to be considered as a asinzen affiliate
              </p>
            </div>
          </div>

          <Card
            className="card-signup header-solid h-full ant-card pt-0"
            bordered="false"
          >
            <Form
              form={form1}
              name="form-1"
              id="form-1"
              className="row-col"
              layout="vertical"
              onFinish={onForm1Finish}
              style={{ display: step === 1 ? "block" : "none" }}
            >
              <div style={{ display: step === 1 ? "block" : "none" }}>
                <div className="title-step-1">
                  Fill out the questions below and click next to proceed
                </div>
                <Form.Item
                  name="reason"
                  label="What is the primary reason you want to promote asinzen tools?"
                  rules={[
                    {
                      required: true,
                      message: "Please input your answer!",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  name="radioAnswerSubscibed"
                  label="Are you currently subscribed to any asinzen tools?"
                  rules={[{ required: true, message: "Please choose!" }]}
                >
                  <Radio.Group
                    onChange={(e) => setAnswerSubscribed(e.target.value)}
                  >
                    <Radio value="Yes">Yes</Radio>
                    <Radio value="No">No</Radio>
                  </Radio.Group>
                </Form.Item>
                {answerSubscribed === "Yes" && (
                  <Form.Item
                    name="emailYourAccount"
                    label="Yes, you are subscribed. What email is your account under?"
                    rules={[
                      {
                        required: true,
                        message: "Please input your answer!",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                )}
                {answerSubscribed === "No" && (
                  <Form.Item
                    name="familiar"
                    label="No, you are not subscribed. How familiar are you with the software?"
                    rules={[{ required: true, message: "Please choose!" }]}
                  >
                    <Radio.Group
                      onChange={(e) => setRadioFamiliar(e.target.value)}
                    >
                      <Radio value="New to your software">
                        New to your software
                      </Radio>
                      <Radio value="Somewhat familiar">Somewhat familiar</Radio>
                      <Radio value="Not familiar">Not familiar</Radio>
                    </Radio.Group>
                  </Form.Item>
                )}
                <Form.Item
                  name="radioAnswerActively"
                  label="Are you actively selling on Amazon?"
                  rules={[{ required: true, message: "Please choose!" }]}
                >
                  <Radio.Group
                    onChange={(e) => setAnswerActively(e.target.value)}
                    value={answerActively}
                    className="ml-10"
                  >
                    <Radio value="Yes">Yes</Radio>
                    <Radio value="No">No</Radio>
                  </Radio.Group>
                </Form.Item>
                {answerActively === "Yes" && (
                  <Form.Item
                    name="howLong"
                    label="Can you tell us how long you've been an Amazon Seller?"
                    rules={[
                      {
                        required: true,
                        message: "Please input your answer!",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                )}
                <div className="mt-25 require">
                  Where do you plan to promote the asinzen products?
                </div>
                <div className="mb-10">
                  Make sure to provide links to your social media channels that
                  we can use to verify your profile.
                </div>
                <Form.Item
                  name="error-promote"
                  className="error-promote"
                ></Form.Item>
                <div className="mb-10" />
                <Form.Item
                  name="facebook"
                  className="promote"
                  label={
                    <Checkbox
                      onChange={(e) =>
                        setCheckbox((state) => ({
                          ...state,
                          facebook: e.target.checked,
                        }))
                      }
                    >
                      Facebook groups I'm a part of
                    </Checkbox>
                  }
                >
                  <Input
                    disabled={!checkbox.facebook}
                    onChange={(e) =>
                      setInputPromote((state) => ({
                        ...state,
                        facebook: e.target.value,
                      }))
                    }
                  />
                </Form.Item>
                <Form.Item
                  name="instagram"
                  className="promote"
                  label={
                    <Checkbox
                      onChange={(e) =>
                        setCheckbox((state) => ({
                          ...state,
                          instagram: e.target.checked,
                        }))
                      }
                    >
                      Instagram
                    </Checkbox>
                  }
                >
                  <Input
                    disabled={!checkbox.instagram}
                    onChange={(e) =>
                      setInputPromote((state) => ({
                        ...state,
                        instagram: e.target.value,
                      }))
                    }
                  />
                </Form.Item>
                <Form.Item
                  name="tiktok"
                  className="promote"
                  label={
                    <Checkbox
                      onChange={(e) =>
                        setCheckbox((state) => ({
                          ...state,
                          tiktok: e.target.checked,
                        }))
                      }
                    >
                      TikTok
                    </Checkbox>
                  }
                >
                  <Input
                    disabled={!checkbox.tiktok}
                    onChange={(e) =>
                      setInputPromote((state) => ({
                        ...state,
                        tiktok: e.target.value,
                      }))
                    }
                  />
                </Form.Item>
                <Form.Item
                  name="youtube"
                  className="promote"
                  label={
                    <Checkbox
                      onChange={(e) =>
                        setCheckbox((state) => ({
                          ...state,
                          youtube: e.target.checked,
                        }))
                      }
                    >
                      My Youtube channel
                    </Checkbox>
                  }
                >
                  <Input
                    disabled={!checkbox.youtube}
                    onChange={(e) =>
                      setInputPromote((state) => ({
                        ...state,
                        youtube: e.target.value,
                      }))
                    }
                  />
                </Form.Item>
                <Form.Item
                  name="facebookAdmin"
                  className="promote"
                  label={
                    <Checkbox
                      onChange={(e) =>
                        setCheckbox((state) => ({
                          ...state,
                          facebookAdmin: e.target.checked,
                        }))
                      }
                    >
                      Facebook groups I'm an admin of
                    </Checkbox>
                  }
                >
                  <Input
                    disabled={!checkbox.facebookAdmin}
                    onChange={(e) =>
                      setInputPromote((state) => ({
                        ...state,
                        facebookAdmin: e.target.value,
                      }))
                    }
                  />
                </Form.Item>
                <Form.Item
                  name="somewhere"
                  className="promote"
                  label={
                    <Checkbox
                      onChange={(e) =>
                        setCheckbox((state) => ({
                          ...state,
                          somewhere: e.target.checked,
                        }))
                      }
                    >
                      Somewhere esle
                    </Checkbox>
                  }
                >
                  <Input
                    disabled={!checkbox.somewhere}
                    onChange={(e) =>
                      setInputPromote((state) => ({
                        ...state,
                        somewhere: e.target.value,
                      }))
                    }
                  />
                </Form.Item>
                <div className="text-right">
                  <Button
                    type="primary"
                    htmlType="submit"
                    onClick={() => setFirstTime(false)}
                  >
                    Next
                  </Button>
                </div>
              </div>
            </Form>
            <Form
              form={form2}
              name="form-2"
              id="form-2"
              className="row-col"
              layout="vertical"
              onFinish={onForm2Finish}
              style={{ display: step === 2 ? "block" : "none" }}
            >
              <p>
                Please note if you are applying on the behalf of your company or
                organization, you must provide us with the real First and Last
                name of the individual who is representing the company or
                organization. Not doing so will void your application.
              </p>
              <div className="d-flex">
                <Form.Item
                  className="flex-1"
                  name="firstName"
                  label="First Name"
                  rules={[
                    {
                      required: true,
                      message: "Please input your first name!",
                    },
                  ]}
                >
                  <Input autoComplete="off" onChange={onChange} />
                </Form.Item>
                <Form.Item
                  className="flex-1 ml-5"
                  name="lastName"
                  label="Last Name"
                  rules={[
                    {
                      required: true,
                      message: "Please input your last name!",
                    },
                  ]}
                >
                  <Input autoComplete="off" onChange={onChange} />
                </Form.Item>
              </div>
              <Form.Item name="companyName" label="Company / Organization Name">
                <Input onChange={onChange} />
              </Form.Item>
              <Form.Item
                name="email"
                label="Email"
                rules={[
                  { required: true, message: "Please input your email!" },
                  {
                    type: "email",
                    message: "The input is not valid email!",
                  },
                ]}
              >
                <Input onChange={onChange} />
              </Form.Item>
              <Form.Item
                name="paypalEmail"
                label="Paypal Email Address you want to receive affiliate payments"
                rules={[
                  {
                    required: true,
                    message: "Please input your PayPal email!",
                  },
                  {
                    type: "email",
                    message: "The input is not valid email!",
                  },
                ]}
              >
                <Input autoComplete="off" onChange={onChange} />
              </Form.Item>
              <Form.Item name="paypalName" label="Paypal Name">
                <Input autoComplete="off" onChange={onChange} />
              </Form.Item>
              <div className="label-bottom">
                We use this to ensure you get your payment.{" "}
                <span
                  className="link-pointer"
                  onClick={() =>
                    window.open("https://help.asinzen.com/paypalname")
                  }
                >
                  Click to learn where to find this
                </span>
                .
              </div>
              <Form.Item
                name="code"
                label="Set your Referral Partner Code"
                rules={[
                  {
                    required: true,
                    message: "Please input your referral partner code!",
                  },
                  { min: 6, message: "Code must be minimum 6 characters" },
                  {
                    pattern: new RegExp("^[a-zA-Z0-9]{4,}$"),
                    message:
                      "Value is only number & char, no special char, no space",
                  },
                ]}
              >
                <Input autoComplete="off" onChange={onChange} />
              </Form.Item>
              <div className="label-bottom">
                This code is part of the links we generate that you share to
                earn affiliate commissions.{" "}
                <span
                  className="link-pointer"
                  onClick={() =>
                    window.open("https://gethelp.asinzen.com/partnercode")
                  }
                >
                  Learn more here
                </span>
                .
              </div>
              <Form.Item
                name="password"
                label="Password"
                rules={[
                  {
                    required: true,
                    message: "Please input your password!",
                  },
                ]}
              >
                <Input.Password
                  autoComplete="new-password"
                  onChange={onChange}
                />
              </Form.Item>
              <Form.Item
                name="confirmPassword"
                label="Confirm Password"
                rules={[
                  {
                    required: true,
                    message: "Please input your confirm password!",
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue("password") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error(
                          "The confirm password that you entered do not match!"
                        )
                      );
                    },
                  }),
                ]}
              >
                <Input.Password autoComplete="off" onChange={onChange} />
              </Form.Item>
              <Form.Item
                name="checkTerms"
                label=""
                rules={[
                  ({ getFieldValue }) => ({
                    validator() {
                      if (checkTerms) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error(
                          "Please check Affiliate Terms and Conditions!"
                        )
                      );
                    },
                  }),
                ]}
              >
                <Checkbox
                  className="mt-5 mb-10"
                  onChange={(e) => onCheckTerms(e)}
                >
                  By clicking "Sign Up" I confirm that I have read, understand,
                  acknowledge, and accept the{" "}
                  <a
                    href="https://goto.asinzen.com/partnersaffilateterms"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Affiliate Terms and Conditions
                  </a>{" "}
                  and I agree to be bound by them.
                </Checkbox>
              </Form.Item>

              {message && (
                <Alert
                  className="alert"
                  message={message.text}
                  type={message.type}
                />
              )}
              <Form.Item>
                <Button
                  style={{ width: "100%" }}
                  type="primary"
                  htmlType="submit"
                  loading={isRegister}
                >
                  SIGN UP
                </Button>
              </Form.Item>
            </Form>
            {(step === 1 || step === 2) && (
              <p className="font-semibold text-muted text-center">
                Already have an account?{" "}
                <Link to="/sign-in" className="font-bold text-dark">
                  Sign In
                </Link>
              </p>
            )}
            {step === 3 && (
              <div className="success-screen">
                <p>
                  Thanks for applying to become an affiliate. Your application
                  has been received and is currently under review.
                </p>
                <p>
                  What's next? After reviewing your application if we feel you
                  are a good fit for our affiliate program we will email you
                  instructions on how to get started. Please note the review
                  process usually takes around 24 hours. If you don't hear back
                  from us please email support@asinzen.com.
                </p>
              </div>
            )}
          </Card>
        </Content>
        <Footer>
          <CopyRight />
        </Footer>
      </div>
    </>
  );
};

export default connectAutoDispatch(() => ({}), {})(SignUpContainer);
